import axios from "axios";

export const transferService = {
  getTransfersService: (params) =>
    axios.get("/transfer", { auth: true, params: params }),

  reTransfersService: (id) =>
    axios.patch(`/transfer/${id}`, {}, { auth: true }),
};
